require('./bootstrap');

$(document).ready(function () {
  $.ajaxSetup({
    headers: {
      'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]').content
    }
  });

  var slideWrapper = $(".main-slider"),
    iframes = slideWrapper.find('.embed-player'),
    lazyImages = slideWrapper.find('.slide-image'),
    lazyCounter = 0;

  // POST commands to YouTube or Vimeo API
  function postMessageToPlayer(player, command) {
    if (player == null || command == null) return;
    player.contentWindow.postMessage(JSON.stringify(command), "*");
  }

  // When the slide is changing
  function playPauseVideo(slick, control) {
    var currentSlide, slideType, startTime, player, video;

    currentSlide = slick.find(".slick-current");
    slideType = currentSlide.attr("class").split(" ")[1];
    player = currentSlide.find("iframe").get(0);
    startTime = currentSlide.data("video-start");

    if (slideType === "vimeo") {
      switch (control) {
        case "play":
          if ((startTime != null && startTime > 0) && !currentSlide.hasClass('started')) {
            currentSlide.addClass('started');
            postMessageToPlayer(player, {
              "method": "setCurrentTime",
              "value": startTime
            });
          }
          postMessageToPlayer(player, {
            "method": "play",
            "value": 1
          });
          break;
        case "pause":
          postMessageToPlayer(player, {
            "method": "pause",
            "value": 1
          });
          break;
      }
    } else if (slideType === "youtube") {
      switch (control) {
        case "play":
          postMessageToPlayer(player, {
            "event": "command",
            "func": "mute"
          });
          postMessageToPlayer(player, {
            "event": "command",
            "func": "playVideo"
          });
          break;
        case "pause":
          postMessageToPlayer(player, {
            "event": "command",
            "func": "pauseVideo"
          });
          break;
      }
    } else if (slideType === "video") {
      video = currentSlide.children("video").get(0);
      if (video != null) {
        if (control === "play") {
          video.play();
        } else {
          video.pause();
        }
      }
    }
  }

  // Resize player
  function resizePlayer(iframes, ratio) {
    if (!iframes[0]) return;
    var win = $(".main-slider"),
      width = win.width(),
      playerWidth,
      height = win.height(),
      playerHeight,
      ratio = ratio || 16 / 9;

    iframes.each(function () {
      var current = $(this);
      if (width / ratio < height) {
        playerWidth = Math.ceil(height * ratio);
        current.width(playerWidth).height(height).css({
          left: (width - playerWidth) / 2,
          top: 0
        });
      } else {
        playerHeight = Math.ceil(width / ratio);
        current.width(width).height(playerHeight).css({
          left: 0,
          top: (height - playerHeight) / 2
        });
      }
    });
  }

  // DOM Ready
  $(function () {
    // Initialize
    slideWrapper.on("init", function (slick) {
      slick = $(slick.currentTarget);
      setTimeout(function () {
        playPauseVideo(slick, "play");
      }, 1000);
      resizePlayer(iframes, 16 / 9);
    });
    slideWrapper.on("beforeChange", function (event, slick) {
      slick = $(slick.$slider);
      playPauseVideo(slick, "pause");
    });
    slideWrapper.on("afterChange", function (event, slick) {
      slick = $(slick.$slider);
      playPauseVideo(slick, "play");
    });
    slideWrapper.on("lazyLoaded", function (event, slick, image, imageSource) {
      lazyCounter++;
      if (lazyCounter === lazyImages.length) {
        lazyImages.addClass('show');
        // slideWrapper.slick("slickPlay");
      }
    });

    //start the slider
    slideWrapper.slick({
      autoplay: true,
      autoplaySpeed: 5000,
      lazyLoad: "progressive",
      speed: 1000,
      arrows: true,
      fade: true,
      dots: true,
      // cssEase: "cubic-bezier(0.87, 0.03, 0.41, 0.9)"
    });
  });

  // Resize event
  $(window).on("resize.slickVideoPlayer", function () {
    resizePlayer(iframes, 16 / 9);
  });

  // Positive message timeout
  setTimeout(function () {
    $('.message.positive').animate({
      height: 'toggle',
      opacity: 'toggle'
    }, 500);
  }, 5000);

  // Accordion
  if ($(".toggle .toggle-title").hasClass('active')) {
    $(".toggle .toggle-title.active").closest('.toggle').find('.toggle-inner').show();
  }
  $(".toggle .toggle-title").click(function () {
    if ($(this).hasClass('active')) {
      $(this).removeClass("active").closest('.toggle').find('.toggle-inner').slideUp(200);
    } else {
      $(this).addClass("active").closest('.toggle').find('.toggle-inner').slideDown(200);
    }
  });

  // Default Slick Slider
  $('.default-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    waitForAnimate: false,
    fade: true,
    cssEase: 'linear',
    autoplay: true,
    autoplaySpeed: 6000
  });

  // Node Slick Slider
  // $('.nodeslider').slick({
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   arrows: true,
  //   dots: false,
  //   fade: true,
  //   prevArrow: $('.nodeslider__prev'),
  //   nextArrow: $('.nodeslider__next'),
  //   cssEase: 'linear',
  //   autoplay: false,
  //   autoplaySpeed: 3000
  // });

  // Convert .svg image to SVG format (add class="svg")
  $('img.svg').each(function () {
    var $img = $(this);
    var imgID = $img.attr('id');
    var imgClass = $img.attr('class');
    var imgURL = $img.attr('src');

    $.get(imgURL, function (data) {
      // Get the SVG tag, ignore the rest
      var $svg = $(data).find('svg');

      // Add replaced image's ID to the new SVG
      if (typeof imgID !== 'undefined') {
        $svg = $svg.attr('id', imgID);
      }

      // Add replaced image's classes to the new SVG
      if (typeof imgClass !== 'undefined') {
        $svg = $svg.attr('class', imgClass + ' replaced-svg');
      }

      // Remove any invalid XML tags as per http://validator.w3.org
      $svg = $svg.removeAttr('xmlns:a');

      // Replace image with new SVG
      $img.replaceWith($svg);
    }, 'xml');
  });
});

function thisURL(params) {
  var url,
    thisURL = document.location.pathname;

  if (params === 1) {
    // option = 1 = full page name with all parameters eg: products.php?id_product=1
    thisURLwithParam = thisURL.substring(0, (thisURL.indexOf('#') == -1) ? thisURL.length : thisURL.indexOf('#'));
    thisURLwithParam = thisURLwithParam.substring(0, getPosition(thisURL, '/', 2));
    url = thisURLwithParam;
  } else {
    // option = null = just the page name (eg: products.php)
    thisURL = thisURL.substring(0, (thisURL.indexOf('#') == -1) ? thisURL.length : thisURL.indexOf('#'));
    thisURL = thisURL.substring(0, (thisURL.indexOf('?') == -1) ? thisURL.length : thisURL.indexOf('?'));
    thisURL = thisURL.substring(0, getPosition(thisURL, '/', 2));
    url = thisURL;
  }

  if (url == '/') {
    url = '/home';
  }

  return url;
}

function thisSubURL(params) {
  var url,
    thisSubURL = document.location.pathname;

  if (params === 1) {
    // option = 1 = full page name with all parameters eg: products.php?id_product=1
    thisURLwithParam = thisSubURL.substring(0, (thisSubURL.indexOf('#') == -1) ? thisSubURL.length : thisSubURL.indexOf('#'));
    thisURLwithParam = thisURLwithParam.substring(0, getPosition(thisSubURL, '/', 3));
    url = thisURLwithParam;
  } else {
    // option = null = just the page name (eg: products.php)
    thisSubURL = thisSubURL.substring(0, (thisSubURL.indexOf('#') == -1) ? thisSubURL.length : thisSubURL.indexOf('#'));
    thisSubURL = thisSubURL.substring(0, (thisSubURL.indexOf('?') == -1) ? thisSubURL.length : thisSubURL.indexOf('?'));
    thisSubURL = thisSubURL.substring(0, getPosition(thisSubURL, '/', 3));
    url = thisSubURL;
  }

  if (url == '/') {
    url = '/home';
  }

  return url;
}

function getPosition(string, subString, index) {
  return string.split(subString, index).join(subString).length;
}


// -- Individual Product Page Tabs

$(function () {
  $(".tabs-nav a").click(function () {
    $(".tabs-nav li").removeClass("active");
    $(this)
      .parent()
      .addClass("active");

    let currentTab = $(this).attr("href");
    $(".tabs-content div").fadeOut(200);
    $(currentTab)
      .delay(200)
      .fadeIn(300);

    return false;
  });
});

// --	Loader Spinner
$(window).on("load", function () {
  $(".preloader").fadeOut("fast");
});


// -- YouTube, Vimeo Video Ratio

var $allVideos = $("iframe[src^='https://www.youtube.com'], iframe[src^='https://youtube.com'], iframe[src^='https://player.vimeo.com']"),

  // The element that is fluid width
  $fluidEl = $("#home-2col-text-1-col2");

// Figure out and save aspect ratio for each video
$allVideos.each(function () {
  $(this).data('aspectRatio', this.height / this.width)
    // and remove the hard coded width/height
    .removeAttr('height')
    .removeAttr('width');
});

// When the window is resized
$(window).resize(function () {
  var newWidth = $fluidEl.width();

  // Resize all videos according to their own aspect ratio
  $allVideos.each(function () {
    var $el = $(this);
    $el.width(newWidth).height(newWidth * $el.data('aspectRatio'));
  });

  // Kick off one resize to fix all videos on page load
}).resize();


// -- Slider Nav

// Node Slick Slider
$('.nodeslider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  fade: true,
  prevArrow: $('.nodeslider__prev'),
  nextArrow: $('.nodeslider__next'),
  cssEase: 'linear',
  autoplay: false,
  autoplaySpeed: 3000
});


$(".nodeslider__nav").slick({
  slidesToShow: 8,
  slidesToScroll: 1,
  asNavFor: ".nodeslider",
  focusOnSelect: true,
  arrows: false,
});


// -- Corporate Video Modal on Home

new modalVideo('.js-modal-btn');


// -- Run Mobile Nav

let mobileNav = window.matchMedia('(max-width: 767px)');

if (mobileNav) {
  // -- Slider Menu

  document.addEventListener(
    "DOMContentLoaded", () => {
      new Mmenu("#menu", {
        slidingSubmenus: false,
        "extensions": [
          "pagedim-black",
        ]
      }, {
        "offCanvas": {
          clone: true
        }
      });
    }
  );
}
